
import './App.css';
import Footer from './Components/Footer/Footer';
import NavbarComponent from './Components/Navbar/Navbar';
import PipelineSection from './Components/Pipeline/Pipeline';
import ProcessSummary from './Components/ProcessSummary/Process';
import ProductionCapacity from './Components/ProductionCapacity/Production';
import ScaleUPSection from './Components/ScaleUp/ScaleUp';
import ShowCase from './Components/ShowCase/ShowCase';
import Stockholder from './Components/Stockholder/Stockholder';


function App() {
  return (
    <div className="App">
      <NavbarComponent/>
      <div className='page-wrapper'>
      </div> 
     <ShowCase/>
      <ScaleUPSection/>
      <Stockholder/>
      <PipelineSection/>
      <ProductionCapacity/> 
      <ProcessSummary/>
     
      <Footer/> 
    </div>
  );
}

export default App;
